module.exports = __webpack_public_path__ + "res/img_top_center.a6e7fee3145b901453074977359a0679.png";